// extracted by mini-css-extract-plugin
module.exports = {"title":"InputTitle_title__YpAjw"};